import { fetchNotificationContactsThunk } from './fetchNotificationContactsThunk';
export default fetchNotificationContactsThunk;
